
import { Component, Prop, Vue } from 'vue-property-decorator'
// floating-vueのcssデフォルト設定を取得
import 'floating-vue/dist/style.css'

/**
 * クリック表示のツールチップ
 *   template(#target): クリック対象指定
 *   template(#content): 表示内容指定
 */
@Component
export default class ClickTooltip extends Vue {
  /** ツールチップの位置指定(指定なしの場合ライブライ側で自動調整) */
  @Prop()
  placement?: string
}
